/*
 * お客様の声（トップ・Judge.me 自動）を左へ流す。sections/sk-home-voice-reviews.liquid 専用。
 *
 * - 流すかどうかは Liquid が決める（auto_scroll ON かつカード3件以上 → data-auto="true"・
 *   ボタンとこのスクリプトもその時だけ出る）。CSS はその時、JS が動く前から流れる時と
 *   同じ全幅の並びで描く。ここでは「動きを減らす」設定や幅が測れない時に .is-static へ戻す。
 * - カードを複製し、「カード1組の幅×k ≥ 表示幅」の半分を2つ並べて、CSS で
 *   translateX 0→-50% を繰り返す。複製は aria-hidden、中のリンクは tabindex=-1。
 *   1組の幅はカードの位置から測り、track の幅もその2倍に固定する（Safari は
 *   max-content の横並びの幅を中の文字の長さから大きく見積もることがあるため）。
 * - マウスを乗せると CSS で一時停止。触る・横スクロール・キーボードでカードに入ると、
 *   その瞬間の位置を scrollLeft に移して止め、指やトラックパッドで動かせるようにする。
 *   6秒操作が無ければ同じ位置から流れを再開する。一時停止ボタンで止めた時は自動で再開しない。
 */
(function () {
  'use strict';

  if (window.__skHomeVoiceLifecycle) {
    window.__skHomeVoiceLifecycle.init(document);
    return;
  }

  var SPEEDS = { slow: 22, normal: 32, fast: 48 }; // px/秒
  var RESUME_DELAY = 6000;
  var MIN_CARDS = 3;

  function toArray(list) { return Array.prototype.slice.call(list); }

  function currentOffset(track) {
    var t = window.getComputedStyle(track).transform;
    var Matrix = window.DOMMatrixReadOnly || window.WebKitCSSMatrix;
    if (!t || t === 'none' || !Matrix) return 0;
    return -new Matrix(t).m41;
  }

  function setup(wrap) {
    if (wrap.__skHomeVoice) return;
    var viewport = wrap.querySelector('[data-sk-home-voice-viewport]');
    var track = wrap.querySelector('[data-sk-home-voice-track]');
    var toggle = wrap.querySelector('[data-sk-home-voice-toggle]');
    var label = toggle && toggle.querySelector('[data-sk-home-voice-toggle-label]');
    if (!viewport || !track || !toggle || !label) return;

    var originals = toArray(track.querySelectorAll('[data-sk-home-voice-card]'));
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var speedKey = wrap.getAttribute('data-speed');
    var speed = Object.prototype.hasOwnProperty.call(SPEEDS, speedKey) ? SPEEDS[speedKey] : SPEEDS.normal;
    var st = { mode: 'static', userPaused: false, hover: false, focus: false, timer: 0, resizeTimer: 0, half: 0, width: 0 };
    var listeners = [];

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      listeners.push([target, type, fn, opts]);
    }

    function eligible() {
      return wrap.getAttribute('data-auto') === 'true' && originals.length >= MIN_CARDS && !(reduce && reduce.matches);
    }

    function clearClones() {
      toArray(track.querySelectorAll('[data-sk-home-voice-clone]')).forEach(function (el) {
        el.parentNode.removeChild(el);
      });
    }

    function build() {
      clearClones();
      track.style.width = '';
      var last = originals[originals.length - 1];
      var setWidth = last.getBoundingClientRect().right - originals[0].getBoundingClientRect().left +
        (parseFloat(window.getComputedStyle(last).marginRight) || 0);
      var view = viewport.clientWidth;
      if (!(setWidth > 0) || !view) return false;
      var k = Math.max(1, Math.ceil(view / setWidth));
      var frag = document.createDocumentFragment();
      for (var copy = 1; copy < k * 2; copy++) {
        originals.forEach(function (card) {
          var clone = card.cloneNode(true);
          clone.removeAttribute('data-sk-home-voice-card');
          clone.setAttribute('data-sk-home-voice-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          toArray(clone.querySelectorAll('a, button, [tabindex]')).forEach(function (el) {
            el.setAttribute('tabindex', '-1');
          });
          frag.appendChild(clone);
        });
      }
      track.appendChild(frag);
      st.half = setWidth * k;
      st.width = view;
      track.style.width = Math.round(st.half * 2 * 100) / 100 + 'px';
      track.style.setProperty('--sk-home-voice-duration', (st.half / speed).toFixed(2) + 's');
      return true;
    }

    function setLabel() {
      label.textContent = toggle.getAttribute(st.userPaused ? 'data-label-play' : 'data-label-pause');
      toggle.setAttribute('data-state', st.userPaused ? 'paused' : 'playing');
    }

    function toManual() {
      if (st.mode !== 'auto') return;
      var offset = currentOffset(track) + viewport.scrollLeft;
      wrap.classList.remove('is-auto');
      wrap.classList.add('is-manual');
      track.style.animationDelay = '';
      st.mode = 'manual';
      viewport.scrollLeft = offset;
    }

    // force: 「再開」ボタンを押した時。マウスが列に乗っていても、フォーカスがカードに
    // 残っていても（Safari はボタンを押してもフォーカスが移らない）必ず再開する。
    function toAuto(force) {
      if (st.mode !== 'manual' || st.userPaused) return;
      if (!force && (st.hover || st.focus)) return;
      var phase = st.half ? viewport.scrollLeft % st.half : 0;
      track.style.animationDelay = (-phase / speed).toFixed(3) + 's';
      st.mode = 'auto';
      viewport.scrollLeft = 0;
      wrap.classList.remove('is-manual');
      wrap.classList.add('is-auto');
    }

    function schedule() {
      clearTimeout(st.timer);
      if (!st.userPaused) st.timer = setTimeout(function () { toAuto(false); }, RESUME_DELAY);
    }

    function interact() {
      toManual();
      schedule();
    }

    function reveal(el) {
      var card = el && el.closest ? el.closest('[data-sk-home-voice-card]') : null;
      if (!card) return;
      var left = card.offsetLeft;
      var right = left + card.offsetWidth;
      if (left < viewport.scrollLeft || right > viewport.scrollLeft + viewport.clientWidth) {
        viewport.scrollLeft = Math.max(0, left - 24);
      }
    }

    function start() {
      if (!eligible() || !build()) {
        wrap.classList.add('is-static');
        return;
      }
      wrap.classList.remove('is-static');
      setLabel();
      // 一時停止中や、キーボードでカードにいる間は、作り直しても流し始めない
      if (st.userPaused || st.focus) {
        st.mode = 'manual';
        wrap.classList.add('is-manual');
      } else {
        st.mode = 'auto';
        track.style.animationDelay = '0s';
        wrap.classList.add('is-auto');
      }
    }

    function stop() {
      clearTimeout(st.timer);
      wrap.classList.remove('is-auto', 'is-manual', 'is-static');
      track.style.animationDelay = '';
      track.style.width = '';
      clearClones();
      viewport.scrollLeft = 0;
      st.mode = 'static';
    }

    function restart() {
      stop();
      start();
    }

    on(viewport, 'pointerenter', function (e) { if (e.pointerType === 'mouse') st.hover = true; });
    on(viewport, 'pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      st.hover = false;
      if (st.mode === 'manual') schedule();
    });
    on(viewport, 'touchstart', interact, { passive: true });
    on(viewport, 'wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) interact();
    }, { passive: true });
    on(viewport, 'scroll', function () {
      if (st.mode === 'auto') {
        if (viewport.scrollLeft !== 0) interact();
      } else if (st.mode === 'manual') {
        schedule();
      }
    }, { passive: true });
    on(viewport, 'focusin', function (e) {
      st.focus = true;
      clearTimeout(st.timer);
      toManual();
      reveal(e.target);
    });
    on(viewport, 'focusout', function (e) {
      if (e.relatedTarget && viewport.contains(e.relatedTarget)) return;
      st.focus = false;
      if (st.mode === 'manual') schedule();
    });
    on(toggle, 'click', function () {
      st.userPaused = !st.userPaused;
      setLabel();
      if (st.userPaused) {
        clearTimeout(st.timer);
        toManual();
      } else {
        toAuto(true);
      }
    });
    on(window, 'resize', function () {
      clearTimeout(st.resizeTimer);
      st.resizeTimer = setTimeout(function () {
        if (st.mode !== 'static' && viewport.clientWidth === st.width) return;
        restart();
      }, 200);
    });
    if (reduce) {
      if (reduce.addEventListener) on(reduce, 'change', restart);
      else if (reduce.addListener) reduce.addListener(restart);
    }

    wrap.__skHomeVoice = {
      destroy: function () {
        clearTimeout(st.resizeTimer);
        stop();
        listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
        if (reduce && !reduce.addEventListener && reduce.removeListener) reduce.removeListener(restart);
        wrap.__skHomeVoice = null;
      }
    };
    start();
  }

  function scopeOf(root) { return root && root.querySelectorAll ? root : document; }

  function init(root) {
    toArray(scopeOf(root).querySelectorAll('[data-sk-home-voice-marquee]')).forEach(setup);
  }

  function cleanup(root) {
    toArray(scopeOf(root).querySelectorAll('[data-sk-home-voice-marquee]')).forEach(function (wrap) {
      if (wrap.__skHomeVoice) wrap.__skHomeVoice.destroy();
    });
  }

  window.__skHomeVoiceLifecycle = { init: init, cleanup: cleanup };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { cleanup(e.target); });
  init(document);
})();
